<script>
  export default {
    name: 'MTableEvents',
    data () {

      /**
       * event listeners which will be binded on each {@link MTableHeader} component. It used by mixins
       * @type {Object.<String, Array<function>>}
       */
      this.headerEventsListeners = {};

      /**
       * event listeners which will be binded on each {@link MTableCell} component. It used by mixins
       * @type {Object.<String, Array<function>>}
       */
      this.cellEventsListeners = {};
      return {};
    },
    methods: {

      /**
       * add {@param listener} into {@link cellEventsListeners}. Used by mixins
       * @param event {String}
       * @param listener {function}
       */
      registerCellEventsListener (event, listener) {
        this.cellEventsListeners[event] = this.cellEventsListeners[event] || [];
        this.cellEventsListeners[event].push(listener);
      },

      /**
       * remove {@param listener} from {@link cellEventsListeners}. Used by mixins
       * @param event {String}
       * @param listener {function}
       */
      unregisterCellEventsListener (event, listener) {
        const idx = this.cellEventsListeners[event].findIndex(item => item === listener);
        this.cellEventsListeners[event].splice(idx, 1);
      },

      /**
       * add {@param listener} into {@link headerEventsListeners}. Used by mixins
       * @param event {String}
       * @param listener {function}
       */
      registerHeaderEventsListener (event, listener) {
        this.headerEventsListeners[event] = this.headerEventsListeners[event] || [];
        this.headerEventsListeners[event].push(listener);
      },

      /**
       * remove {@param listener} from {@link headerEventsListeners}. Used by mixins
       * @param event {String}
       * @param listener {function}
       */
      unregisterHeaderEventsListener (event, listener) {
        const idx = this.headerEventsListeners[event].findIndex(item => item === listener);
        this.headerEventsListeners[event].splice(idx, 1);
      }

    }
  };
</script>
